export const obscureEmail = (email: string): string => {
  const [localPart, domain] = email.split('@')
  if (localPart.length <= 2) {
    return `${localPart[0]}***@${domain}`
  }
  const obscuredLocal = localPart[0] + '***' + localPart[localPart.length - 1]
  return `${obscuredLocal}@${domain}`
}
